import { AnalyticsFilterKeys, ReviewFilterKeys, SimulationsFilterKeys } from '../types';

export const DATE_FILTER_KEYS: string[] = [
  SimulationsFilterKeys.DATE_CREATED,
  ReviewFilterKeys.CALL_DATE,
  AnalyticsFilterKeys.DATE_RANGE,
];
